/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-list-header',
  templateUrl: 'list-header.component.html',
  styleUrls: ['list-header.component.scss'],
})
export class ListHeaderComponent {
  @Input() title: string;
}
